export const sortAgents = (a, b) => {
  if (!a.activeForAutoAssignChat && b.activeForAutoAssignChat) return 1
  if (a.activeForAutoAssignChat && !b.activeForAutoAssignChat) return -1
  if (a.fullName > b.fullName) return 1
  if (a.fullName < b.fullName) return -1
  return 0
}
